<template>
  <div class="columns is-block is-clearfix">
    <div class="column is-full pb-0 mb-0" v-if="!searchDefinitions.hide_title">
      <div class="section-heading filter-heading site-page-heading pb-0">
        <h3 v-html="searchDefinitions.title"></h3>
      </div>
    </div>
    <aside class="aside-column column is-12-mobile is-4-tablet is-pulled-left hide-for-print">

      <div class="section-heading filter-heading"></div>
      <site-page-keyword :color="themeColor"></site-page-keyword>

      <div class="content mb-3">
        <div class="tools-search">
          <!--
          <button v-if="switchGrid" @click="grid = !grid" class="toggle-list">
            <svg v-if="grid" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-layout-list-icon lucide-layout-list">
              <rect width="7" height="7" x="3" y="3" rx="1" />
              <rect width="7" height="7" x="3" y="14" rx="1" />
              <path d="M14 4h7" />
              <path d="M14 9h7" />
              <path d="M14 15h7" />
              <path d="M14 20h7" />
            </svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-layout-grid-icon lucide-layout-grid">
              <rect width="7" height="7" x="3" y="3" rx="1" />
              <rect width="7" height="7" x="14" y="3" rx="1" />
              <rect width="7" height="7" x="14" y="14" rx="1" />
              <rect width="7" height="7" x="3" y="14" rx="1" />
            </svg>
          </button>
          -->
          <span class="search-result has-text-weight-medium has-text-dark">
            {{ searchInfo.pagination.total }}
            {{ searchInfo.pagination.total == 1 ? "Result" : "Results" }}
          </span>
        </div>
      </div>
      <template v-if="!switchGrid && searchInfo.data.length > 0">
        <site-page-results></site-page-results>
        <hr class="is-hidden-tablet -mt-2" />
      </template>
    </aside>
    <div class="content-column column is-12-mobile is-8-tablet is-12-print is-pulled-left">
      <site-page-filters :color="themeColor" class="hide-for-print"></site-page-filters>

      <site-page-article v-if="!switchGrid && searchInfo.data.length > 0"></site-page-article>
    </div>
    <div v-if="switchGrid && searchInfo.data.length > 0" class="content-column column is-full is-pulled-left">
      <site-page-results-grid :cols="gridColumns"></site-page-results-grid>
    </div>
    <div v-if="searchInfo.data.length == 0" class="content-column column is-full is-pulled-left">
      <div class="empty-articles">
        <p>No articles found</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SitePageSearch",
  props: {
    switchGrid: {
      type: Boolean,
      default: false
    },
    gridColumns: {
      type: Number,
      default: 3
    },
    themeColor: {
      type: String,
      required: '',
    },
    apiUrl: {
      type: String,
      required: true,
    },
    apiArticleUrl: {
      type: String,
      required: true,
    },
    results: {
      type: Object,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
    searchDefinitions: {
      type: Object,
      required: true,
    },
    filterOptions: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      searchInfo: "getSearchInfo",
      searchFilters: "getSearchFilters",
    }),
  },
  data() {
    return {
      grid: false
    }
  },
  mounted() {
    const formattedFacets = {};
    const selectedArticle =
      this.results.data.length > 0 ? this.results.data[0].location_id : null;

    for (let filterIndex in this.results.facets) {
      formattedFacets[filterIndex] = {
        showedOptions: this.results.facets[filterIndex].options.slice(0, 3),
        hiddenOptions: this.results.facets[filterIndex].options.slice(3),
      };
    }

    this.$store.dispatch("assignApiUrl", this.apiUrl);
    this.$store.dispatch("assignApiArticleUrl", this.apiArticleUrl);
    this.$store.dispatch("assignGeneralSearchInfo", {
      ...this.results,
      facets: formattedFacets,
    });

    this.$store.dispatch("assignGeneralSearchFilters", this.filters);
    this.$store.dispatch("assignSearchDefinitions", this.searchDefinitions);
    this.$store.dispatch("assignSearchFilterOptions", this.filterOptions);

    if (selectedArticle !== null) {
      this.$store.dispatch("assignSelectedArticle", this.results.data[0]);
      this.$store.dispatch("fetchArticleContent", selectedArticle);
    }
  },
};
</script>
